import { WEB_COMPONENT_MSP_IN_PRODUCT_TRIALS_OVERLAY_CONTENT } from '../../../../webcomponents.constants';
import { MspInProductTrialsOverlayContentWebComponent } from './component/MspInProductTrialsOverlayContentWebComponent';

export { MspInProductTrialsOverlayContentWebComponent };

window.customElements.define(WEB_COMPONENT_MSP_IN_PRODUCT_TRIALS_OVERLAY_CONTENT, MspInProductTrialsOverlayContentWebComponent);
